export default __webpack_public_path__ + "64311030bfd545d0083aec8eefab905e.png";